import React from 'react'
import { Helmet } from 'react-helmet-async'

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-ss-white pt-16">
      <Helmet>
        <title>О нас — SwedenSound</title>
        <meta name="description" content="SwedenSound — профессиональная акустика и микрофонные системы европейского качества. Доставка по всей России." />
      </Helmet>

      {/* Hero with background image */}
      <section className="relative overflow-hidden text-white py-20">
        <div className="absolute inset-0" style={{ backgroundImage: `url('/backgrounds/bg-home-karaoke.jpg?v=2')`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundColor: '#1a1a1a' }} />
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative mx-auto max-w-ss px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-light tracking-tight">
            О SwedenSound
          </h1>
          <p className="mt-4 text-white/60 max-w-3xl mx-auto text-lg leading-relaxed">
            Мы создаём профессиональное звуковое оборудование, объединяя европейские стандарты качества
            с доступной ценой. Наши системы работают на сценах, в караоке-барах, конференц-залах
            и репетиционных базах по всей России.
          </p>
        </div>
      </section>

      <section className="py-20 sm:py-28">
        <div className="mx-auto max-w-ss px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                title: 'Европейское звучание',
                desc: 'Каждая деталь спроектирована с фокусом на надёжность и акустическую точность. Корпуса из МДФ и ABS, усилители класса D и AB, DSP-процессоры.',
              },
              {
                title: 'Для профессионалов',
                desc: 'Системы рассчитаны на ежедневную эксплуатацию в прокате, инсталляции и на сцене. Ударопрочные корпуса, защита от перегрузок, надёжные разъёмы.',
              },
              {
                title: 'Доставка по РФ',
                desc: 'Отправляем в любой город России. Гарантия на всё оборудование. Техническая поддержка и консультации по подбору системы.',
              },
            ].map((item) => (
              <div key={item.title} className="bg-white rounded-xl p-6 sm:p-8 border border-ss-border">
                <h3 className="text-lg font-semibold text-ss-text mb-3">{item.title}</h3>
                <p className="text-sm text-ss-muted leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}
